import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-categories-dropdown',
  templateUrl: './categories-dropdown.component.html',
  styleUrl: './categories-dropdown.component.scss'
})
export class CategoriesDropdownComponent {

  @Input() dataSource:any[] = []
  @Input() label:string = "Common.MainCategory"
  @Input() isRequired:boolean = false
  @Output() setSelected: EventEmitter<any> = new EventEmitter();

  form: FormGroup= this.fb.group({
    Id: new FormControl(""),
  });;

  reset(){
    this.form.reset()
    this.setSelected.emit("")
  }
  constructor(
    private fb: FormBuilder,
  ) { }

  ngOnInit(){
    if(this.isRequired){
      this.form.get('Id')?.addValidators(Validators.required)
    }
  }

  onClick(){
    let selected = this.form.get('Id')?.value
    let item = this.dataSource.find(i=>i.Id==selected)
    this.setSelected.emit(item)
  }
}
